import { useSelector }                            from 'react-redux'
import { appCdnUrl }                              from '../../../utilities'
import SettingsShopProductFormVariationsTableItem from './SettingsShopProductFormVariationsTableItem'

export default function SettingsShopProductFormVariationsTable( props: any ): JSX.Element {
  const { handleVariantChange, variants, images, isColourVariation, isSizeVariation } = props

  const shopVariants: any           = useSelector( ( state: any ): any => state.shop.variants )
  const shopVariantsVariations: any = useSelector( ( state: any ): any => state.shop.variantsVariations )

  return (
    <div className="flex flex-col w-full">
      <div className="flex font-bold p-4 xl:p-6 w-full space-x-4">
        <div className="flex justify-center flex-col w-full">
          <div>Image</div>
        </div>

        { isColourVariation &&
          <div className="flex justify-center flex-col w-full">
            <div>Colour</div>
          </div>
        }

        { isSizeVariation &&
          <div className="flex justify-center flex-col w-full">
            <div>Size</div>
          </div>
        }

        <div className="flex justify-center flex-col w-full">
          <div>Quantity</div>
        </div>

        <div className="flex justify-center flex-col w-full">
          <div>Order</div>
        </div>

        <div className="flex justify-center flex-col w-full">
          <div>Price (&pound;)</div>
        </div>

        <div className="flex"><span className="w-8">&nbsp;</span></div>
      </div>

      { variants.map( ( variant: any, index: any ): any =>
                        <SettingsShopProductFormVariationsTableItem
                          key={ index }
                          tIndex={ index }
                          variant={ variant }
                          images={ images }
                          appCdnUrl={ appCdnUrl }
                          isColourVariation={ isColourVariation }
                          isSizeVariation={ isSizeVariation }
                          shopVariants={ shopVariants }
                          shopVariantsVariations={ shopVariantsVariations }
                          handleVariantChange={ handleVariantChange }
                        /> ) }

      <SettingsShopProductFormVariationsTableItem
        images={ images }
        appCdnUrl={ appCdnUrl }
        isColourVariation={ isColourVariation }
        isSizeVariation={ isSizeVariation }
        shopVariants={ shopVariants }
        shopVariantsVariations={ shopVariantsVariations }
        handleVariantChange={ handleVariantChange }
      />
    </div>
  )
}
